var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e02639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca1a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc2235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca1a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd9c2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df2034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca1a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b4bad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08429a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.904762,
    cy: 1.904762,
    fill: "#fff",
    fillRule: "evenodd",
    r: 1.904762
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.904762,
    cy: 1.904762,
    fill: "#fff",
    fillRule: "evenodd",
    r: 1.904762
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.904762,
    cy: 1.904762,
    fill: "#fff",
    fillRule: "evenodd",
    r: 1.904762
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.904762,
    cy: 1.904762,
    fill: "#fff",
    fillRule: "evenodd",
    r: 1.904762
  })), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.904762,
    cy: 1.904762,
    fill: "#fff",
    fillRule: "evenodd",
    r: 1.904762
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.380952h16v3.047619h-16z",
    fill: "url(#d)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.047619h16v5.333333h-16z",
    fill: "url(#a)",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6.095238 3.809524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.809524v1.904762h-3.809524z",
    fill: "url(#e)",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.76190476 1.14285714h2.28571429l-.38095238.76190476h-1.52380953z",
    fill: "#fff",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.52380952 0h.76190477v1.13928804c0 .21236535-.17671131.38452148-.38095239.38452148-.21039418 0-.38095238-.1630743-.38095238-.38452148zm-.76190476.76190476s.57142857 1.14285714 1.14285714 1.14285714c.57142858 0 1.14285715-1.14285714 1.14285715-1.14285714v.76190476c0 .42078838-.33726502.76190477-.76110976.76190477h-.76349477c-.42034931 0-.76110976-.33818272-.76110976-.76190477z",
    fill: "url(#f)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.285714h3.809524v1.52381h-3.809524z",
    fill: "url(#g)",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.66666667h3.80952381v.38095238h-3.80952381z",
    fill: "#fff",
    mask: "url(#m)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPf);
export default __webpack_public_path__ + "static/media/PF.e1624df909c19f9fb7871cc0410a59d9.svg";
export { ForwardRef as ReactComponent };